import { useMutation, useQuery } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { bonusesApi } from '../api/bonuses.api';
import type { ManualBonusAdjustDto } from '../types';

export const useBonusUsers = (phone?: string) => {
  return useQuery({
    queryKey: ['bonus-users', phone ?? ''],
    queryFn: () => bonusesApi.getUsers(phone),
  });
};

export const useManualBonusAdjust = () => {
  return useMutation({
    mutationFn: (data: ManualBonusAdjustDto) => bonusesApi.manualAdjust(data),
    onSuccess: (_, variables) => {
      const action = variables.type === 'accrue' ? 'Начисление' : 'Списание';
      notifications.show({
        title: 'Успешно',
        message: `${action} бонусов выполнено`,
        color: 'green',
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: 'Ошибка',
        message: error?.response?.data?.message || 'Не удалось выполнить операцию',
        color: 'red',
      });
    },
  });
};
